import React, { useState } from 'react';
import { Calendar, BookOpen, Home, School, Clock, CheckCircle, XCircle, AlertCircle, Save, Plus, FileText, Award, User, Heart, Activity, TrendingUp, ClipboardList, Edit2, Send, MessageSquare, Users, Eye, Check, X, Pill, Syringe, BarChart3 } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

// COMPREHENSIVE INTEGRATED DATA (same as before)
const DEMO_DATA = {
  currentTeacher: {
    id: 'tchr_001',
    firstName: 'Sarah',
    lastName: 'Mitchell',
    email: 'sarah.mitchell@brischool.edu',
    subjects: ['English']
  },

  myPerformance: {
    classAverage: 85.2,
    studentCount: 125,
    completionRate: 94,
    feedbackRating: 4.6,
    subjectAverage: 83.5,
    ranking: 1,
    improvementRate: 5.8,
    atRiskStudents: 3
  },

  classPerformanceBreakdown: [
    { classId: 'cls_001', name: '7A English', students: 25, avgGrade: 85.2, attendance: 95.2, atRisk: 1, excelling: 6 },
    { classId: 'cls_002', name: '8B English', students: 28, avgGrade: 84.8, attendance: 94.5, atRisk: 1, excelling: 7 },
    { classId: 'cls_003', name: '9A English', students: 30, avgGrade: 86.1, attendance: 93.8, atRisk: 1, excelling: 8 },
    { classId: 'cls_004', name: '10C English', students: 22, avgGrade: 83.5, attendance: 94.0, atRisk: 0, excelling: 5 },
    { classId: 'cls_005', name: '11B English', students: 20, avgGrade: 87.2, attendance: 95.5, atRisk: 0, excelling: 6 }
  ],
  
  students: [
    { id: 'stud_001', firstName: 'Oliver', lastName: 'Wright', yearGroup: 'Year 7', gender: 'M', dob: '2012-05-12', 
      address: '123 Oak Street', emergencyContact: 'Mrs. Wright - 555-0101', parentId: 'par_001',
      medicalNotes: 'Asthma - inhaler in nurse office', hasIEP: false, hasMedical: true,
      bloodType: 'A+',
      conditions: ['Asthma'],
      allergies: [],
      medications: [
        { name: 'Albuterol Inhaler', dosage: '2 puffs as needed', frequency: 'As needed' }
      ],
      currentGrade: 85.2,
      attendance: 95.0,
      status: 'excelling'
    },
    { id: 'stud_002', firstName: 'Amelia', lastName: 'Johnson', yearGroup: 'Year 7', gender: 'F', dob: '2012-08-23',
      address: '456 Elm Avenue', emergencyContact: 'Mr. Johnson - 555-0102', parentId: 'par_002',
      medicalNotes: '', hasIEP: true, hasMedical: false,
      bloodType: 'B+',
      conditions: [],
      allergies: [],
      medications: [],
      currentGrade: 78.5,
      attendance: 92.0,
      status: 'on-track'
    },
    { id: 'stud_003', firstName: 'Noah', lastName: 'Davis', yearGroup: 'Year 7', gender: 'M', dob: '2012-03-15',
      address: '789 Pine Road', emergencyContact: 'Mrs. Davis - 555-0103', parentId: 'par_003',
      medicalNotes: '', hasIEP: false, hasMedical: false,
      bloodType: 'O+',
      conditions: [],
      allergies: [],
      medications: [],
      currentGrade: 88.2,
      attendance: 96.5,
      status: 'excelling'
    },
    { id: 'stud_004', firstName: 'Isla', lastName: 'Brown', yearGroup: 'Year 7', gender: 'F', dob: '2012-11-07',
      address: '321 Maple Drive', emergencyContact: 'Mr. Brown - 555-0104', parentId: 'par_004',
      medicalNotes: 'Peanut allergy - EpiPen required', hasIEP: false, hasMedical: true,
      bloodType: 'O-',
      conditions: [],
      allergies: ['Peanuts', 'Tree Nuts'],
      medications: [
        { name: 'EpiPen', dosage: '0.3mg', frequency: 'Emergency only' }
      ],
      currentGrade: 91.5,
      attendance: 98.0,
      status: 'excelling'
    },
    { id: 'stud_005', firstName: 'Leo', lastName: 'Martinez', yearGroup: 'Year 7', gender: 'M', dob: '2012-06-30',
      address: '654 Cedar Lane', emergencyContact: 'Mrs. Martinez - 555-0105', parentId: 'par_005',
      medicalNotes: '', hasIEP: false, hasMedical: false,
      bloodType: 'A-',
      conditions: [],
      allergies: [],
      medications: [],
      currentGrade: 62.0,
      attendance: 88.5,
      status: 'at-risk',
      concerns: 'Low attendance, falling behind in written assignments'
    }
  ],
  
  classes: [
    { id: 'cls_001', name: '7A English', teacherId: 'tchr_001', subject: 'English', yearGroup: 'Year 7',
      studentIds: ['stud_001', 'stud_002', 'stud_003', 'stud_004', 'stud_005'] }
  ],

  assessments: [
    { 
      id: 'assess_001', 
      title: 'Romeo and Juliet Essay', 
      classId: 'cls_001', 
      dueDate: '2024-12-30', 
      totalPoints: 100,
      instructions: 'Write a 500-word essay analyzing the theme of fate in Romeo and Juliet.',
      questions: [
        { id: 'q1', text: 'Thesis Statement (20 points)', type: 'essay' },
        { id: 'q2', text: 'Evidence and Analysis (60 points)', type: 'essay' },
        { id: 'q3', text: 'Conclusion (20 points)', type: 'essay' }
      ],
      status: 'available'
    }
  ],

  submissions: [
    { 
      id: 'sub_001',
      assessmentId: 'assess_001',
      studentId: 'stud_001',
      submittedAt: '2024-12-28T14:30:00',
      status: 'submitted',
      answers: [
        { questionId: 'q1', text: 'In Romeo and Juliet, Shakespeare presents fate as an unstoppable force...' },
        { questionId: 'q2', text: 'Throughout the play, Shakespeare uses various literary devices...' },
        { questionId: 'q3', text: 'In conclusion, Shakespeare masterfully weaves the theme of fate...' }
      ],
      feedback: null,
      score: null
    }
  ],

  meetingRequests: [
    {
      id: 'meet_001',
      type: 'incoming',
      parentId: 'par_001',
      parentName: 'Sarah Wright',
      studentId: 'stud_001',
      studentName: 'Oliver Wright',
      reason: 'Academic Progress',
      preferredDate: '2025-01-05',
      preferredTime: 'afternoon',
      notes: 'Would like to discuss Oliver\'s excellent progress',
      status: 'pending',
      submittedAt: '2024-12-27T09:00:00'
    }
  ]
};

const BriSchoolTeacherBootstrap = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [reviewingSubmission, setReviewingSubmission] = useState(null);
  const [viewingHealth, setViewingHealth] = useState(null);

  const [submissions, setSubmissions] = useState(DEMO_DATA.submissions);
  const [meetingRequests, setMeetingRequests] = useState(DEMO_DATA.meetingRequests);
  const [feedbackForm, setFeedbackForm] = useState({ feedback: '', score: '' });

  const submitFeedback = () => {
    const updatedSubmissions = submissions.map(sub =>
      sub.id === reviewingSubmission.id
        ? {
            ...sub,
            feedback: feedbackForm.feedback,
            score: parseInt(feedbackForm.score),
            status: 'graded',
            gradedAt: new Date().toISOString()
          }
        : sub
    );
    
    setSubmissions(updatedSubmissions);
    setReviewingSubmission(null);
    setFeedbackForm({ feedback: '', score: '' });
    showNotification('Feedback submitted successfully!');
  };

  const respondToMeeting = (requestId, response) => {
    setMeetingRequests(meetingRequests.map(req => 
      req.id === requestId 
        ? { ...req, status: response, respondedAt: new Date().toISOString() }
        : req
    ));
    showNotification(`Meeting ${response}!`);
  };

  const showNotification = (message) => {
    // Bootstrap toast would go here, using simple alert for now
    alert(message);
  };

  const getStudentById = (id) => DEMO_DATA.students.find(s => s.id === id);
  const getClassStudents = () => DEMO_DATA.students.filter(s => DEMO_DATA.classes[0].studentIds.includes(s.id));

  const getPerformanceColor = (grade) => {
    if (grade >= 85) return 'text-success';
    if (grade >= 75) return 'text-info';
    if (grade >= 65) return 'text-warning';
    return 'text-danger';
  };

  const getStatusBadge = (status) => {
    if (status === 'excelling') return 'badge bg-success';
    if (status === 'at-risk') return 'badge bg-danger';
    return 'badge bg-info';
  };

  // Viewing Student Health Record
  if (viewingHealth) {
    const student = viewingHealth;

    return (
      <div className="min-vh-100 bg-light">
        <nav className="navbar navbar-light bg-white border-bottom shadow-sm">
          <div className="container-fluid">
            <button onClick={() => setViewingHealth(null)} className="btn btn-link text-decoration-none">
              ← Back
            </button>
            <span className="navbar-brand mb-0 h1">
              <Heart className="me-2" size={32} style={{color: '#dc3545'}} />
              Student Health Information - {student.firstName} {student.lastName}
            </span>
          </div>
        </nav>

        <div className="container py-4">
          <div className="card shadow">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <h5>Medical Information</h5>
                  <div className="list-group">
                    <div className="list-group-item d-flex justify-content-between">
                      <span>Blood Type:</span>
                      <strong className="text-danger">{student.bloodType}</strong>
                    </div>
                    <div className="list-group-item d-flex justify-content-between">
                      <span>Emergency Contact:</span>
                      <strong>{student.emergencyContact}</strong>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <h5>Medical Alerts</h5>
                  {student.medicalNotes && (
                    <div className="alert alert-danger">
                      <AlertCircle className="me-2" size={20} />
                      <strong>{student.medicalNotes}</strong>
                    </div>
                  )}
                </div>
              </div>

              {student.conditions.length > 0 && (
                <div className="mt-4">
                  <h5><Activity className="me-2" size={20} style={{color: '#dc3545'}} />Medical Conditions</h5>
                  <div className="row">
                    {student.conditions.map((condition, idx) => (
                      <div key={idx} className="col-md-6 mb-2">
                        <div className="alert alert-danger mb-0">{condition}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {student.allergies.length > 0 && (
                <div className="mt-4">
                  <h5><AlertCircle className="me-2" size={20} style={{color: '#ffc107'}} />Allergies</h5>
                  <div className="row">
                    {student.allergies.map((allergy, idx) => (
                      <div key={idx} className="col-md-6 mb-2">
                        <div className="alert alert-warning mb-0">{allergy}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {student.medications.length > 0 && (
                <div className="mt-4">
                  <h5><Pill className="me-2" size={20} style={{color: '#0d6efd'}} />Current Medications</h5>
                  {student.medications.map((med, idx) => (
                    <div key={idx} className="card bg-light mb-2">
                      <div className="card-body">
                        <h6 className="card-title">{med.name}</h6>
                        <div className="row">
                          <div className="col-md-6">
                            <small className="text-muted">Dosage:</small>
                            <p className="mb-0">{med.dosage}</p>
                          </div>
                          <div className="col-md-6">
                            <small className="text-muted">Frequency:</small>
                            <p className="mb-0">{med.frequency}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Reviewing Submission View
  if (reviewingSubmission) {
    const student = getStudentById(reviewingSubmission.studentId);
    const assessment = DEMO_DATA.assessments.find(a => a.id === reviewingSubmission.assessmentId);

    return (
      <div className="min-vh-100 bg-light">
        <nav className="navbar navbar-light bg-white border-bottom shadow-sm">
          <div className="container-fluid">
            <button onClick={() => setReviewingSubmission(null)} className="btn btn-link text-decoration-none">
              ← Back
            </button>
            <span className="navbar-brand mb-0 h1">
              Review Submission - {student.firstName} {student.lastName}
            </span>
          </div>
        </nav>

        <div className="container py-4">
          <div className="row">
            <div className="col-lg-8">
              <div className="card shadow mb-4">
                <div className="card-body">
                  <h5>Student Submission</h5>
                  {assessment.questions.map((question, idx) => {
                    const answer = reviewingSubmission.answers.find(a => a.questionId === question.id);
                    return (
                      <div key={question.id} className="mb-4 pb-3 border-bottom">
                        <h6>Question {idx + 1}: {question.text}</h6>
                        <div className="bg-light rounded p-3">
                          <p className="mb-0">{answer?.text || 'No answer provided'}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card shadow sticky-top" style={{top: '20px'}}>
                <div className="card-body">
                  <h5 className="card-title">Grade Submission</h5>
                  
                  <div className="mb-3">
                    <label className="form-label">Score (out of {assessment.totalPoints})</label>
                    <input
                      type="number"
                      min="0"
                      max={assessment.totalPoints}
                      value={feedbackForm.score}
                      onChange={(e) => setFeedbackForm({ ...feedbackForm, score: e.target.value })}
                      className="form-control form-control-lg"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Feedback</label>
                    <textarea
                      value={feedbackForm.feedback}
                      onChange={(e) => setFeedbackForm({ ...feedbackForm, feedback: e.target.value })}
                      placeholder="Provide constructive feedback..."
                      rows="8"
                      className="form-control"
                    />
                  </div>

                  <button
                    onClick={submitFeedback}
                    disabled={!feedbackForm.score || !feedbackForm.feedback}
                    className="btn btn-primary w-100"
                  >
                    <Send className="me-2" size={16} />
                    Submit Grade & Feedback
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <nav className="navbar navbar-light bg-white border-bottom shadow-sm">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">
            <School className="me-2" size={32} style={{color: '#0d6efd'}} />
            BriSchool Teacher Portal
          </span>
          <div className="d-flex align-items-center">
            <div className="text-end me-3">
              <div className="fw-bold">{DEMO_DATA.currentTeacher.firstName} {DEMO_DATA.currentTeacher.lastName}</div>
              <small className="text-muted">{DEMO_DATA.currentTeacher.subjects.join(', ')}</small>
            </div>
            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
                 style={{width: '40px', height: '40px', fontWeight: 'bold'}}>
              {DEMO_DATA.currentTeacher.firstName[0]}{DEMO_DATA.currentTeacher.lastName[0]}
            </div>
          </div>
        </div>
      </nav>

      {/* Navigation Tabs */}
      <div className="bg-white border-bottom">
        <div className="container-fluid">
          <ul className="nav nav-pills py-2">
            <li className="nav-item">
              <button onClick={() => setActiveTab('dashboard')} className={`nav-link ${activeTab === 'dashboard' ? 'active' : ''}`}>
                <Home size={16} className="me-2" />Dashboard
              </button>
            </li>
            <li className="nav-item">
              <button onClick={() => setActiveTab('performance')} className={`nav-link ${activeTab === 'performance' ? 'active' : ''}`}>
                <BarChart3 size={16} className="me-2" />My Performance
              </button>
            </li>
            <li className="nav-item">
              <button onClick={() => setActiveTab('students')} className={`nav-link ${activeTab === 'students' ? 'active' : ''}`}>
                <Users size={16} className="me-2" />Student Health
              </button>
            </li>
            <li className="nav-item">
              <button onClick={() => setActiveTab('assessments')} className={`nav-link ${activeTab === 'assessments' ? 'active' : ''}`}>
                <ClipboardList size={16} className="me-2" />Assessments
              </button>
            </li>
            <li className="nav-item">
              <button onClick={() => setActiveTab('meetings')} className={`nav-link ${activeTab === 'meetings' ? 'active' : ''}`}>
                <MessageSquare size={16} className="me-2" />Meetings
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-fluid py-4">
        {activeTab === 'dashboard' && (
          <div>
            <h2 className="mb-4">Dashboard</h2>
            
            <div className="row g-4 mb-4">
              <div className="col-md-4">
                <div className="card text-white bg-success shadow h-100" role="button" onClick={() => setActiveTab('performance')}>
                  <div className="card-body">
                    <BarChart3 size={32} className="mb-2" />
                    <h6 className="card-subtitle mb-2">Class Average</h6>
                    <h2 className="card-title">{DEMO_DATA.myPerformance.classAverage}%</h2>
                    <small>View my performance →</small>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card text-white bg-warning shadow h-100" role="button" onClick={() => setActiveTab('assessments')}>
                  <div className="card-body">
                    <ClipboardList size={32} className="mb-2" />
                    <h6 className="card-subtitle mb-2">Pending Reviews</h6>
                    <h2 className="card-title">{submissions.filter(s => s.status === 'submitted').length}</h2>
                    <small>Review submissions →</small>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card text-white bg-danger shadow h-100" role="button" onClick={() => setActiveTab('students')}>
                  <div className="card-body">
                    <Heart size={32} className="mb-2" />
                    <h6 className="card-subtitle mb-2">Medical Alerts</h6>
                    <h2 className="card-title">{getClassStudents().filter(s => s.hasMedical).length}</h2>
                    <small>View student health →</small>
                  </div>
                </div>
              </div>
            </div>

            <h4 className="mb-3">7A English - Student Overview</h4>
            <div className="card shadow">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Student</th>
                      <th className="text-center">Grade</th>
                      <th className="text-center">Attendance</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Medical</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getClassStudents().map(student => (
                      <tr key={student.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                                 style={{width: '32px', height: '32px', fontSize: '12px', fontWeight: 'bold'}}>
                              {student.firstName[0]}{student.lastName[0]}
                            </div>
                            <div>
                              <div className="fw-bold">{student.firstName} {student.lastName}</div>
                              <small className="text-muted">{student.yearGroup}</small>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">
                          <span className={`fw-bold fs-5 ${getPerformanceColor(student.currentGrade)}`}>
                            {student.currentGrade}%
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="text-info fw-bold">{student.attendance}%</span>
                        </td>
                        <td className="text-center">
                          <span className={getStatusBadge(student.status)}>
                            {student.status === 'excelling' ? 'Excelling' : student.status === 'at-risk' ? 'At Risk' : 'On Track'}
                          </span>
                        </td>
                        <td className="text-center">
                          {student.hasMedical || student.conditions.length > 0 || student.allergies.length > 0 ? (
                            <button
                              onClick={() => setViewingHealth(student)}
                              className="btn btn-sm btn-outline-danger"
                            >
                              <Heart size={16} />
                            </button>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                        <td className="text-center">
                          <button className="btn btn-sm btn-primary">View Profile</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'performance' && (
          <div>
            <h2 className="mb-4">My Teaching Performance</h2>

            <div className="row g-4 mb-4">
              <div className="col-md-3">
                <div className="card border-success shadow-sm">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <TrendingUp size={32} className="text-success" />
                      <span className="badge bg-success">+{DEMO_DATA.myPerformance.improvementRate}%</span>
                    </div>
                    <h6 className="text-muted">Class Average</h6>
                    <h2 className="text-success mb-0">{DEMO_DATA.myPerformance.classAverage}%</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card border-info shadow-sm">
                  <div className="card-body">
                    <Users size={32} className="text-info mb-2" />
                    <h6 className="text-muted">Completion Rate</h6>
                    <h2 className="text-info mb-0">{DEMO_DATA.myPerformance.completionRate}%</h2>
                    <small className="text-muted">{DEMO_DATA.myPerformance.studentCount} students</small>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card border-warning shadow-sm">
                  <div className="card-body">
                    <Award size={32} className="text-warning mb-2" />
                    <h6 className="text-muted">Student Feedback</h6>
                    <h2 className="text-warning mb-0">{DEMO_DATA.myPerformance.feedbackRating}</h2>
                    <small className="text-muted">out of 5.0</small>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card border-primary shadow-sm">
                  <div className="card-body">
                    <BarChart3 size={32} className="text-primary mb-2" />
                    <h6 className="text-muted">Department Ranking</h6>
                    <h3 className="text-primary mb-0">#{DEMO_DATA.myPerformance.ranking}</h3>
                    <small className="text-muted">Top Performer</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow">
              <div className="card-header">
                <h5 className="mb-0">Performance by Class</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Class</th>
                      <th className="text-center">Students</th>
                      <th className="text-center">Avg Grade</th>
                      <th className="text-center">Attendance</th>
                      <th className="text-center">At Risk</th>
                      <th className="text-center">Excelling</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DEMO_DATA.classPerformanceBreakdown.map(cls => (
                      <tr key={cls.classId}>
                        <td className="fw-bold">{cls.name}</td>
                        <td className="text-center">{cls.students}</td>
                        <td className="text-center">
                          <span className={`fw-bold ${getPerformanceColor(cls.avgGrade)}`}>{cls.avgGrade}%</span>
                        </td>
                        <td className="text-center text-info fw-bold">{cls.attendance}%</td>
                        <td className="text-center">
                          <span className="badge bg-danger">{cls.atRisk}</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-success">{cls.excelling}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'students' && (
          <div>
            <h2 className="mb-4">Student Health Information</h2>

            <div className="row g-4">
              {getClassStudents().map((student, idx) => (
                <div key={student.id} className="col-md-6 col-lg-4">
                  <div className={`card shadow h-100 ${student.hasMedical || student.conditions.length > 0 || student.allergies.length > 0 ? 'border-danger' : ''}`}>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h5 className="card-title mb-1">{student.firstName} {student.lastName}</h5>
                          <p className="text-muted mb-0">{student.yearGroup}</p>
                        </div>
                        <span className="badge bg-danger">{student.bloodType}</span>
                      </div>

                      {student.medicalNotes && (
                        <div className="alert alert-danger py-2 mb-3">
                          <AlertCircle size={16} className="me-2" />
                          <small><strong>{student.medicalNotes}</strong></small>
                        </div>
                      )}

                      {student.conditions.length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted d-block mb-1">Conditions:</small>
                          {student.conditions.map((cond, i) => (
                            <span key={i} className="badge bg-danger me-1 mb-1">{cond}</span>
                          ))}
                        </div>
                      )}

                      {student.allergies.length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted d-block mb-1">Allergies:</small>
                          {student.allergies.map((allergy, i) => (
                            <span key={i} className="badge bg-warning text-dark me-1 mb-1">{allergy}</span>
                          ))}
                        </div>
                      )}

                      {student.medications.length > 0 && (
                        <div className="mb-3">
                          <small className="text-muted d-block mb-1">Medications:</small>
                          {student.medications.map((med, i) => (
                            <div key={i} className="bg-light rounded p-2 mb-1">
                              <small><strong>{med.name}</strong> - {med.dosage}</small>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="pt-3 border-top mb-3">
                        <small className="text-muted d-block mb-1">Emergency Contact:</small>
                        <small className="fw-bold">{student.emergencyContact}</small>
                      </div>

                      <button
                        onClick={() => setViewingHealth(student)}
                        className="btn btn-danger w-100"
                      >
                        <Heart size={16} className="me-2" />
                        View Full Health Record
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'assessments' && (
          <div>
            <h2 className="mb-4">Assessment Submissions</h2>

            {DEMO_DATA.assessments.map(assessment => {
              const assessmentSubmissions = submissions.filter(s => s.assessmentId === assessment.id);
              const pending = assessmentSubmissions.filter(s => s.status === 'submitted');

              return (
                <div key={assessment.id} className="card shadow mb-4">
                  <div className="card-header">
                    <h5 className="mb-0">{assessment.title}</h5>
                  </div>
                  <div className="card-body">
                    {pending.length > 0 ? (
                      <div className="list-group">
                        {pending.map(sub => {
                          const student = getStudentById(sub.studentId);
                          return (
                            <div key={sub.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                                     style={{width: '40px', height: '40px', fontWeight: 'bold'}}>
                                  {student.firstName[0]}{student.lastName[0]}
                                </div>
                                <div>
                                  <h6 className="mb-0">{student.firstName} {student.lastName}</h6>
                                  <small className="text-muted">Submitted: {new Date(sub.submittedAt).toLocaleString()}</small>
                                </div>
                              </div>
                              <button
                                onClick={() => setReviewingSubmission(sub)}
                                className="btn btn-primary"
                              >
                                <Eye size={16} className="me-2" />
                                Review
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="text-muted mb-0">No pending submissions</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {activeTab === 'meetings' && (
          <div>
            <h2 className="mb-4">Meeting Requests</h2>

            {meetingRequests.filter(m => m.type === 'incoming').length > 0 ? (
              <div className="row g-4">
                {meetingRequests.filter(m => m.type === 'incoming').map(request => (
                  <div key={request.id} className="col-md-6">
                    <div className="card shadow">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <h5 className="card-title">{request.parentName}</h5>
                            <p className="text-muted mb-1">Student: {request.studentName}</p>
                            <p className="text-muted mb-0">Reason: {request.reason}</p>
                          </div>
                          <span className={`badge ${
                            request.status === 'pending' ? 'bg-warning' :
                            request.status === 'accepted' ? 'bg-success' : 'bg-danger'
                          }`}>
                            {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                          </span>
                        </div>

                        {request.status === 'pending' && (
                          <div className="d-grid gap-2">
                            <button
                              onClick={() => respondToMeeting(request.id, 'accepted')}
                              className="btn btn-success"
                            >
                              <Check size={16} className="me-2" />
                              Accept
                            </button>
                            <button
                              onClick={() => respondToMeeting(request.id, 'declined')}
                              className="btn btn-danger"
                            >
                              <X size={16} className="me-2" />
                              Decline
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="card shadow">
                <div className="card-body text-center py-5">
                  <p className="text-muted mb-0">No incoming meeting requests</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BriSchoolTeacherBootstrap;